import { SecurityItemsKeys } from '@/enum/SecurityItems'

export class UiTab {
    public label:string
    public group:string
    public cmp:string
    public icon:string
    public id:number
    public securityKey:SecurityItemsKeys
    public mustBeActive:boolean
    public iris:boolean
    public irisModule:string
    public checkBeforeClose:boolean
    public tryClose:boolean
    public usedFor:Array<number>

    constructor({label = "",group="", cmp="",icon="", id=0,securityKey=SecurityItemsKeys.PILOT_REACH_DETAIL,mustBeActive=false,iris=false,irisModule="",checkBeforeClose = false,tryClose = false, usedFor=[] as Array<number> } = {}) {
        this.label = label
        this.group = group
        this.icon = icon
        this.cmp = cmp
        this.id = id
        this.securityKey = securityKey
        this.mustBeActive = mustBeActive
        this.iris = iris
        this.irisModule = irisModule
        this.checkBeforeClose = checkBeforeClose
        this.tryClose = tryClose
        this.usedFor = usedFor
    }
} 
